import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ContactInfo } from './contactInfo';

@JsonObject('model.customer.QbCustomer')
export class QbCustomer extends AbstractModel {

    @JsonProperty(String, 'id')
    id: string;

    @JsonProperty(String, 'displayName')
    displayName: string;

}